module.exports = __webpack_public_path__ + "static/media/ExchangeRate.7a2d7eed.svg";